// Up-to-two-letter initials for the avatar fallback when a profile has no icon. Mirrors the helper in
// the chat package (kept local to avoid a cross-package dependency for one small function).
export function initials(name?: string | null): string {
  if (!name) return "?"
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return "?"
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
}
